// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FileInput {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px dashed #ccc;
  border-radius: var(--bs-border-radius-xl);
  padding: 20px;
  cursor: pointer;
  transition: border-color 0.3s ease;
}`, "",{"version":3,"sources":["webpack://./src/common/FileInput/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,yCAAA;EACA,aAAA;EACA,eAAA;EACA,kCAAA;AACF","sourcesContent":[".FileInput {\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border: 2px dashed #ccc;\n  border-radius: var(--bs-border-radius-xl);\n  padding: 20px;\n  cursor: pointer;\n  transition: border-color 0.3s ease;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
